import React from "react";
import { KeyRound } from "lucide-react";

// Pixel-identical phone mockup of the Anadear app sign-in screen.
// Only the active tab + helper line change per client type.
const TABS = ["Landlord", "Vendor", "Tenant", "Buyer"];
const HELPER = {
  Landlord: "Track rent, statements & compliance across your portfolio",
  Vendor: "See viewings, offers & live marketing performance",
  Tenant: "Pay rent, report maintenance & view your documents",
  Buyer: "Saved searches, viewings & purchase progress",
};
const DEMO = [
  "landlord@anadear.com",
  "vendor@anadear.com",
  "tenant@anadear.com",
];

export const AppSignInMock = ({ active = "Tenant", testid }) => (
  <div className="w-full max-w-[240px] mx-auto" data-testid={testid}>
    <div className="rounded-[2.2rem] bg-[#1c1c1e] p-2 shadow-[0_22px_60px_rgba(0,0,0,0.22)]">
      <div className="relative rounded-[1.8rem] bg-[#faf7f2] overflow-hidden">
        {/* notch */}
        <div className="absolute top-2 left-1/2 -translate-x-1/2 w-16 h-1.5 rounded-full bg-[#1c1c1e]/80 z-10" />
        <div className="px-5 pt-8 pb-5">
          {/* logo */}
          <div className="text-center mb-4">
            <div className="font-display text-[13px] tracking-[0.22em] text-[#2b2b2b]">ANADEAR</div>
            <div className="text-[7px] tracking-[0.4em] text-[#b8935f]">ESTATES</div>
          </div>
          <h3 className="font-display text-[18px] text-[#2b2b2b] leading-none mb-1">Sign In</h3>
          <p className="text-[8px] text-[#8a8a8a] leading-tight mb-3">Access your {active.toLowerCase()} portal.</p>

          {/* tabs */}
          <div className="flex gap-1 p-1 rounded-lg bg-[#efe7da] mb-3">
            {TABS.map((t) => (
              <span key={t} className={`flex-1 text-center text-[8px] py-1.5 rounded-md transition-colors ${t === active ? "bg-[#b8935f] text-white font-500 shadow-sm" : "text-[#8a8a8a]"}`}>{t}</span>
            ))}
          </div>

          {/* role helper */}
          <div className="flex items-start gap-1.5 rounded-md bg-white border border-[#f0ece5] px-2 py-1.5 mb-3">
            <KeyRound size={10} className="text-[#b8935f] mt-0.5 shrink-0" />
            <span className="text-[7.5px] text-[#6a6a6a] leading-tight">{HELPER[active]}</span>
          </div>

          {/* fields */}
          <p className="text-[7px] text-[#9a9a9a] mb-0.5">Email</p>
          <div className="h-6 rounded-md bg-white border border-[#e2d8c8] mb-2 flex items-center px-2"><span className="text-[7.5px] text-[#b8b0a2]">you@example.com</span></div>
          <p className="text-[7px] text-[#9a9a9a] mb-0.5">Password</p>
          <div className="h-6 rounded-md bg-white border border-[#e2d8c8] mb-3 flex items-center px-2"><span className="text-[9px] tracking-widest text-[#b8b0a2]">••••••••</span></div>

          <div className="h-7 rounded-md bg-[#b8935f] flex items-center justify-center mb-2"><span className="text-[9px] text-white font-500">Sign in</span></div>
          <p className="text-[7px] text-center text-[#8a8a8a] mb-3">New here? <span className="text-[#b8935f]">Create an account</span></p>

          {/* demo accounts */}
          <div className="rounded-md bg-[#f4eee4] px-2 py-1.5">
            <p className="text-[6.5px] text-[#9a9a9a] mb-1">Demo accounts (password: Password123)</p>
            {DEMO.map((d) => (
              <div key={d} className="flex items-center gap-1 mb-0.5"><span className="w-1 h-1 rounded-full bg-[#b8935f]" /><span className="text-[7px] text-[#6a6a6a]">{d}</span></div>
            ))}
          </div>
        </div>
      </div>
    </div>
  </div>
);

export default AppSignInMock;
